<template>
  <section class="content d-flex">
    <section class="side-nav">
      <router-link :to="{name:'Partners'}">Manage partners</router-link>
      <router-link :to="{name:'Partners New'}">Add new partner</router-link>
    </section>

    <section class="main">
      <h1>Add new partner</h1>
    </section>
  </section>
</template>

<script>
export default {
  name: 'Partners',
  data: () => {
    return {
    };
  },
  methods: {

  },
};
</script>

<style lang="scss">

</style>